(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6366],{

/***/ 46383:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app",
      function () {
        return __webpack_require__(38596);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 38596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ app; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/redux-dynamic-middlewares/lib/index.js
var lib = __webpack_require__(83273);
;// CONCATENATED MODULE: ./src/features/builder.js













var addBuilderMdl = function() {
// addMiddleware(...[
//     ...dropMiddleware,
//     ...dataMiddleware,
//     ...mapMiddleware,
//     ...inspectMiddleware,
//     ...updateMiddleware,
//     ...artboardMiddleware,
//     ...canvasMdl,
//     ...screensMdl,
//     ...tokensMdl,
//     ...colorsMdl,
//     ...typesMdl,
//     ...boundsMdl,
// ])
};

// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./src/pages/app/index.js





var Dashboard = dynamic_default()(function() {
    return __webpack_require__.e(/* import() | Dashboard */ 6362).then(__webpack_require__.bind(__webpack_require__, 7394));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7394)
            ];
        }
    },
    ssr: false
});
var AppIndex = function(param) {
    var router = param.router, translated = param.translated;
    var ref;
    (0,react.useEffect)(function() {
        addBuilderMdl();
    }, []);
    // useEffect(() => {
    //     if (navigator?.geolocation) {
    //       navigator.geolocation.getCurrentPosition((location) => {
    //         alert(JSON.stringify(location))
    //         // if (location) dispatch(getUserData(location.coords));
    //       });
    //     }
    //   }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dashboard, {
            translated: translated,
            type: router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.type
        })
    });
};
var __N_SSG = true;
/* harmony default export */ var app = ((0,router.withRouter)(AppIndex));


/***/ }),

/***/ 83273:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = true;
__webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = undefined;

var _redux = __webpack_require__(18717);

var createDynamicMiddlewares = function createDynamicMiddlewares() {
  var allDynamicMiddlewares = [];
  var allApplyedDynamicMiddlewares = [];
  var store = void 0;

  var enhancer = function enhancer(_store) {
    store = _store;
    return function (next) {
      return function (action) {
        return _redux.compose.apply(undefined, allApplyedDynamicMiddlewares)(next)(action);
      };
    };
  };

  var addMiddleware = function addMiddleware() {
    var _allApplyedDynamicMid, _allDynamicMiddleware;

    for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
      middlewares[_key] = arguments[_key];
    }

    (_allApplyedDynamicMid = allApplyedDynamicMiddlewares).push.apply(_allApplyedDynamicMid, middlewares.map(function (middleware) {
      return middleware(store);
    }));
    (_allDynamicMiddleware = allDynamicMiddlewares).push.apply(_allDynamicMiddleware, middlewares);
  };

  var removeMiddleware = function removeMiddleware(middleware) {
    var index = allDynamicMiddlewares.findIndex(function (d) {
      return d === middleware;
    });

    if (index === -1) {
      // eslint-disable-next-line no-console
      console.error('Middleware does not exist!', middleware);

      return;
    }

    allDynamicMiddlewares = allDynamicMiddlewares.filter(function (_, mdwIndex) {
      return mdwIndex !== index;
    });
    allApplyedDynamicMiddlewares = allApplyedDynamicMiddlewares.filter(function (_, mdwIndex) {
      return mdwIndex !== index;
    });
  };

  var resetMiddlewares = function resetMiddlewares() {
    allApplyedDynamicMiddlewares = [];
    allDynamicMiddlewares = [];
  };

  return {
    enhancer: enhancer,
    addMiddleware: addMiddleware,
    removeMiddleware: removeMiddleware,
    resetMiddlewares: resetMiddlewares
  };
};

var dynamicMiddlewaresInstance = createDynamicMiddlewares();

__webpack_unused_export__ = dynamicMiddlewaresInstance.enhancer;
var addMiddleware = dynamicMiddlewaresInstance.addMiddleware,
    removeMiddleware = dynamicMiddlewaresInstance.removeMiddleware,
    resetMiddlewares = dynamicMiddlewaresInstance.resetMiddlewares;
__webpack_unused_export__ = addMiddleware;
__webpack_unused_export__ = removeMiddleware;
__webpack_unused_export__ = resetMiddlewares;
__webpack_unused_export__ = createDynamicMiddlewares;

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(46383); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);